import { useTranslate } from 'utils'
import { MessagePageUI } from 'pages/message-page/message-page'
import { WarningOutlined, HomeOutlined } from '@ant-design/icons'
import { theme } from 'antd'
import { useNavigate } from 'react-router-dom'

type PageErrorProps = {
    message?: string
    style?: object
}

export const PageError = ({ message }: PageErrorProps) => <StaticPageError message={message}/>

type StaticPageErrorProps = {
    message?: string
    description?: string
}

export const StaticPageError = ({ message, description }: StaticPageErrorProps) => {

    const { __ } = useTranslate()
    const { token: { colorPrimary } } = theme.useToken()
    const navigate = useNavigate()

    return (
        <MessagePageUI
            icon={<WarningOutlined/>}
            message={message ?? __`oops_something_went_wrong`}
            description={description ?? __`navigate_to_the_main_page_and_start_fresh`}
            actionButton={{
                text: __`go_to_home`,
                icon: <HomeOutlined style={{ color: colorPrimary }}/>,
                onSelect: () => navigate('/')
            }}
        />
    )
}
